/*
 * Get a nested value from an object using a dot-separated path.
 * Replaces lodash.get to eliminate lodash dependency.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPath = (obj: any, path: string): any =>
  path.split(".").reduce((acc, key) => acc?.[key], obj)
